/* global axios */
import ApiClient from '../ApiClient';

class KanbanBoardsAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { kanban_board: data });
  }

  update(boardId, data) {
    return axios.patch(`${this.url}/${boardId}`, { kanban_board: data });
  }
}

export default new KanbanBoardsAPI();
